import { AspAssignGLAccountRequest } from 'vopay';
import { useState } from 'react';
import { useApi } from '#shared/providers/Api';

export default function useAssignAspGLAccount() {
  const api = useApi();
  const [assigning, setAssigning] = useState(false);

  async function assignAspGLAccount(params: AspAssignGLAccountRequest) {
    try {
      setAssigning(true);
      const res = await api.assignAspGLAccount(params);
      if (!res.Success) throw new Error(res.ErrorMessage);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setAssigning(false);
    }
  }

  return { assigning, assignAspGLAccount };
}
